import { useAnswers } from "./answers";
import { useParticipation } from "./useParticipation";
import { useSettings } from "../settings/context";
import type { Offer } from "./thread";

/**
 * CE QUI RECOMPOSE LE FIL, LU UNE FOIS POUR TOUT LE MONDE.
 *
 * ⚠️ DIX ENDROITS CALCULENT LE FIL — le fil d'Ariane, la garde du shell, chaque bouton
 * « Continuer », les tuiles de l'accueil, le récapitulatif. Le commentaire d'`Offre` dit
 * déjà pourquoi c'est un sac et non des paramètres : celui qui en oublie un ne plante
 * pas, il calcule un fil DIFFÉRENT des autres, et le symptôme est un fil d'Ariane qui
 * annonce « étape 2 sur 3 » avant d'en servir quatre.
 *
 * Ce hook ferme la porte : on ne construit plus l'offre à la main, on la demande. Ajouter
 * une entrée — les conférences, un quota — se fait ici, et les dix la reçoivent.
 *
 * ⚠️ CE QU'ON RÉPOND MAINTENANT, SINON CE QUE LE SERVEUR DÉTIENT — l'ordre de préséance
 * de tout ce tunnel (voir `Registration`, `Typology`, `Dates`). Le premier terme fait
 * réagir le fil au clic même ; le second le garde réduit quand quelqu'un revient sur un
 * refus déjà enregistré, sans repasser par l'étape 1.
 *
 * ⚠️ AUCUNE REQUÊTE DE PLUS : les typologies et les jours voyagent avec le contexte de
 * l'événement, et la participation est déjà lue par le shell — même clé, même cache.
 */
export function useOffer(): Offer {
  const { typos, days } = useSettings();
  const [answers] = useAnswers();
  const { recorded } = useParticipation();

  const participation = answers.participation ?? recorded?.answer;
  return {
    typos,
    days: days,
    ...(participation ? { participation } : {}),
    // Ce qui garde la confirmation ouverte à une inscrite quand la porte se ferme.
    ...(recorded?.responded === true ? { responded: true } : {}),
    // The typology step stays for whoever answered it in this journey (`typoChosen`).
    ...(answers.typoId !== undefined ? { typoChosen: true } : {}),
  };
}
